module.exports = __webpack_public_path__ + "static/media/nutricia-brand-allergens-sulphites.5079984b.svg";